export default "__VITE_ASSET__DMugoyrs__"